<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <template v-if="isAdmin">
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            icon="location_city"
            :title="totalStats.entities"
            :sub-title="$tc('models.entity', 2)"
            color="primary"
          />
        </v-flex>
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            icon="group"
            :title="totalStats.clients"
            :sub-title="$tc('titles.global.client', 2)"
            color="indigo"
          />
        </v-flex>
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            icon="play_arrow"
            :title="totalStats.matches"
            :sub-title="$tc('models.match', 2)"
            color="light-blue"
          />
        </v-flex>
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            icon="chrome_reader_mode"
            icdon="chrome_reader_mode"
            :title="totalStats.subscriptions"
            :sub-title="$t('titles.global.suscriptions')"
            color="purple"
          />
        </v-flex>
      </template>
      <v-flex lg3 sm6 xs12 px-3>
        <mini-statistic
          icon="airplay"
          :title="totalStats.streamedMatches"
          :sub-title="$t('titles.global.streamedMatches')"
          color="red"
        />
      </v-flex>
      <v-flex lg3 sm6 xs12 px-3>
        <mini-statistic
          icon="group"
          :title="totalStats.teams"
          :sub-title="$tc('models.team', 2)"
          color="cyan"
        />
      </v-flex>
      <v-flex lg3 sm6 xs12 px-3>
        <mini-statistic
          icon="person"
          :title="totalStats.trainers"
          :sub-title="$tc('titles.global.trainer', 2)"
          color="blue-grey"
        />
      </v-flex>
      <v-flex lg3 sm6 xs12 px-3>
        <mini-statistic
          icon="person"
          :title="totalStats.players"
          :sub-title="$tc('titles.global.player', 2)"
          color="brown"
        />
      </v-flex>
      <template v-if="isAdmin">
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            type="antmedia"
            :title="antmediaStatus"
            :sub-title="$t('titles.global.antmediaStatus')"
            color="red"
          />
        </v-flex>
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            type="antmedia"
            :title="
              antmediaStatus === 'online' ? streamingCount.antmediaCount : '-'
            "
            :sub-title="$t('titles.global.activeStreamsAntmedia')"
            color="red"
          />
        </v-flex>
        <v-flex lg3 sm6 xs12 px-3>
          <mini-statistic
            type="fbase"
            :title="streamingCount.localCount"
            :sub-title="$t('titles.global.activeStreams')"
            color="primary"
          />
        </v-flex>
      </template>

      <v-flex xs12 px-3>
        <match-list type="liveMatches" />
      </v-flex>
      <v-flex xs12 px-3>
        <training-list type="liveTrainings" />
      </v-flex>
      <v-flex xs12 px-3>
        <match-list type="lastMatches" />
      </v-flex>
      <v-flex xs12 px-3>
        <match-list type="upcomingMatches" />
      </v-flex>
      <v-flex xs12 px-3>
        <pending-users :items="pendingUsers" :loading="loading" />
      </v-flex>
      <v-flex
        v-if="isAdmin && topLocations && topLocations.length"
        xs12
        px-3
        text-xs-center
      >
        <donut-chart
          :title="$t('titles.global.topLocation')"
          :data="topLocations"
        />
      </v-flex>
      <v-flex v-if="populars.entities && populars.entities.length" xs12 px-3>
        <stats-wrapper
          :title="$t('titles.global.populars') + ': ' + $tc('models.entity', 2)"
          only-bar
        >
          <bar-chart slot="bar" :data="populars.entities" :two-bars="false" />
        </stats-wrapper>
      </v-flex>
      <v-flex v-if="populars.teams && populars.teams.length" xs12 px-3>
        <stats-wrapper
          :title="$t('titles.global.populars') + ': ' + $tc('models.team', 2)"
          only-bar
        >
          <bar-chart slot="bar" :data="populars.teams" :two-bars="false" />
        </stats-wrapper>
      </v-flex>
      <v-flex v-if="populars.players && populars.players.length" xs12 px-3>
        <stats-wrapper
          :title="
            $t('titles.global.populars') + ': ' + $tc('titles.global.player', 2)
          "
          only-bar
        >
          <bar-chart slot="bar" :data="populars.players" :two-bars="false" />
        </stats-wrapper>
      </v-flex>
      <v-flex xs12 px-3>
        <top-voting />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MatchList from './dashboard/MatchList'
import PendingUsers from './dashboard/PendingUsers'
import StatsWrapper from './dashboard/StatsWrapper'
import TopVoting from './dashboard/TopVoting'
import TrainingList from './dashboard/TrainingList'

import BarChart from '@/components/widgets/chart/BarChart'
import DonutChart from '@/components/widgets/chart/DonutChart'
import MiniStatistic from '@/components/widgets/stats/MiniStatistic'

export default {
  name: 'Dashboard',
  components: {
    StatsWrapper,
    MiniStatistic,
    PendingUsers,
    MatchList,
    TrainingList,
    TopVoting,
    DonutChart,
    BarChart,
  },
  data: () => ({
    pendingUsersSearch: '',
  }),
  watch: {
    statusOfButton: function (val) {
      if (val) this.init(this).finally(() => this.setStatus(false))
    },
  },
  created() {
    this.init()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
      totalStats: (state) => state.stats.totalStats,
      pendingUsers: (state) => state.stats.pendingUsers.items,
      loading: (state) => state.stats.loading,
      streamingCount: (state) => state.antmedia.streamingCount,
      antmediaStatus: (state) => state.antmedia.antmediaStatus,
    }),
    ...mapGetters({
      topLocations: 'stats/topLocations',
      populars: 'stats/populars',
    }),
    pendingUsersHeaders() {
      return [
        {
          text: this.$t('fields.global.name'),
          align: 'center',
          value: 'name',
        },
        {
          text: this.$tc('models.entity'),
          value: 'entity',
        },
        {
          text: this.$tc('models.role'),
          value: 'role',
        },
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  methods: {
    ...mapActions({
      fetchStats: 'stats/fetchStats',
      fetchActiveLiveStreamCount: 'antmedia/fetchActiveLiveStreamCount',
      fetchAntmediaStatus: 'antmedia/fetchAntmediaStatus',
      setStatus: 'events/setStatus',
    }),
    init() {
      return Promise.all([
        this.fetchStats(this),
        this.fetchActiveLiveStreamCount(),
        this.fetchAntmediaStatus(),
      ])
    },
  },
}
</script>
